import { render } from "./ApartmentCard.vue?vue&type=template&id=484ecb88"
import script from "./ApartmentCard.vue?vue&type=script&lang=js"
export * from "./ApartmentCard.vue?vue&type=script&lang=js"

import "./ApartmentCard.vue?vue&type=style&index=0&id=484ecb88&lang=scss"
script.render = render

export default script